import { RootPaths } from "../App/paths";

export const CHAT_LIST_PATH = "chat";
export const CHAT_LIST_FULL_PATH = `${RootPaths.APP_V2_HOME}/${CHAT_LIST_PATH}`;
